<template>
  <div class="logistics-inquiry">
    <div class="table-container">
      <div class="message">
        <p>名称：{{ customer }}</p>
        <p>快递：{{ expressName }}</p>
      </div>
      <!-- <div class="throw-rule">
        <el-button @click="openRound" class="btn-blue">取整规则</el-button> -->
        <!-- <span>取整规则：</span>
        <p class="input-container">
          <el-select class="gray" v-model="roundId" disabled>
            <el-option
              v-for="item in roundList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </p> -->
        <!-- <span>计抛规则：</span>
        <p class="input-container">
          <el-input class="gray" disabled v-model="throwRule.kg"></el-input>
          <span class="unit">kg</span>
        </p>
        <span>&nbsp;=&nbsp;</span>
        <p class="input-container">
          <el-input class="gray" disabled v-model="throwRule.square"></el-input>
          <span class="unit">m³</span>
        </p> -->
      <!-- </div> -->
      <div
        class="table"
        v-for="(table, tableIndex) in tableList"
        :key="tableIndex"
      >
        <div class="throw-rule">
          <el-button @click="openRound(tableIndex)" class="btn-blue">取整规则</el-button>
        </div>
        <el-table :data="table.tableData" style="width: 100%">
          <el-table-column prop="region" label="地区"></el-table-column>
          <el-table-column
            v-for="(title, index) in table.tableTitle"
            :key="index"
            :prop="title.name"
            :label="
              index + 1 === table.tableTitle.length
                ? title.value + unit
                : title.value + unit
            "
          >
            <el-table-column v-if="!title.fixedPrice" :label="`首重（元/${unit}）`">
              <template slot-scope="scope">
                <p>{{scope.row[title.value].firstWeight}}</p>
              </template>
            </el-table-column>
            <el-table-column v-if="!title.fixedPrice" :label="`续重（元/${unit}）`">
              <template slot-scope="scope">
                <p>{{scope.row[title.value].overPrice}}</p>
              </template>
            </el-table-column>
            <el-table-column v-if="title.fixedPrice" :label="`首重（元/${unit}）`">
              <template slot-scope="scope">
                <p>{{scope.row[title.value]}}</p>
              </template>
            </el-table-column>
          </el-table-column>
          <!-- <el-table-column prop="overPrice" label="续重"></el-table-column> -->
        </el-table>
      </div>
    </div>
    <!-- 取整规则编辑 -->
    <el-dialog
      title="取整规则"
      top="15vh"
      :visible.sync="roundDialog"
      width="600px"
    >
      <div class="border"></div>
      <ul class="list">
        <li
          class="item"
          v-for="(value, index) in tableList[tableTitleIndex].roundTableList"
          :key="index"
        >
          <span>区间{{ index + 1 }}：</span>
          <div class="interval">
            <el-input class="white" v-model="value.start" disabled></el-input>
            <span class="blank">---</span>
            <el-input
              class="white"
              v-model="value.end"
              disabled
            ></el-input>
            <div class="throw-rule">
              <span>取整规则：</span>
              <div class="input-container">
                <el-select class="gray w100" v-model="value.roundType" disabled>
                  <el-option
                    v-for="item in roundList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeRoundDialog">取消</el-button>
        <el-button class="btn-blue" @click="closeRoundDialog"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Logistics from "models/logistics";
const logistics = new Logistics();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      customer: "",
      expressName: "",
      tableList: [
        {
          tableTitle: [],
          tableData: [],
          // 取整规则列表
          roundTableList: [
            {
              start: 0,
              end: "",
              roundType: '',
            },
            {
              start: "",
              end: 9999.9,
              roundType: '',
            },
          ],
        }
      ],
      roundId: "" /* 取整 */,
      roundList: [],
      roundDialog: false,
      tableTitleIndex: 0,
      unit: 'kg'
      // throwRule: {
      //   kg: "",
      //   square: 1
      // }
    };
  },
  created() {
    let customerId = this.$route.query.id;
    this.customer = this.$route.query.name;
    let expressType = this.$route.query.type;
    this.unit = expressType == 3 ? 'm³' : 'kg'
    this.expressName = this.$route.query.expressName;
    modifyNetTitle('客户快递规则详情')
    this.inquiry(customerId, expressType);
    this.initGetRoundList()
  },
  methods: {
    /* 获取取整规则 */
    initGetRoundList() {
      logistics.getRoundList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.code;
            obj.name = value.name;
            arr.push(obj);
          });
          this.roundList = arr
        }
      })
    },
    inquiry(customerId, expressType) {
      logistics.getExpressRuleList(customerId, expressType).then(res => {
        if (res.success) {
          // this.throwRule.kg = res.result.density;
          // this.roundId = res.result.roundType;
          let tableList = [];
          res.result.ruleList.map(tableListItem => {
            let tableObj = {};
            let tableTitle = [];
            let tableData = [];
            let intervalList = [];
            let roundTableList = [];
            tableListItem.section.map((value, index) => {
              let obj = {};
              let obj2 = {};
              obj.name = "interva" + (index + 1);
              obj.value = value.begin + "-" + value.end;
              obj.fixedPrice = value.fixedPrice?true: false;
              obj2.fixedPrice = value.fixedPrice?true: false;
              obj2.start = value.begin;
              obj2.end = value.end;
              obj2.end = value.end;
              tableTitle.push(obj);
              intervalList.push(obj2);
            });
            tableListItem.rules.map(value => {
              let obj = {};
              obj.region = value.province;
              obj.ruleDetail = value.ruleDetail;
              value.ruleDetail.map(v => {
                if (v.over === 0) {
                  obj[v.begin + "-" + v.end] = v.price;
                } else {
                  obj[v.begin + "-" + v.end] = {}
                  obj[v.begin + "-" + v.end].overPrice = v.over;
                  obj[v.begin + "-" + v.end].firstWeight = v.price;
                }
                // tableTitle.map(val => {
                //   let str = v.begin + "-" + v.end
                //   if (val.value === str) {
                //     if (v.over === 0) {
                //       val.fixedPrice = true
                //     } else {
                //       val.fixedPrice = false
                //     }
                //   }
                // })
              })
              tableData.push(obj);
            });
            tableData.map(i => {
              i.ruleDetail.map(v=> {
                intervalList.map((val) => {
                  if (val.start === v.begin && val.end === v.end) {
                    let str = v.begin + "-" + v.end;
                    if (!val.fixedPrice) {
                      i[str] = {}
                      i[str].overPrice = v.over;
                      i[str].firstWeight = v.price;
                    }
                  }
                });
              })
            })
            tableListItem.roundTypeList.map(i => {
              let obj = {}
              obj.start = i.begin
              obj.end = i.end
              obj.roundType = i.roundType
              roundTableList.push(obj)
            })
            tableObj = {
              tableTitle,
              tableData,
              roundTableList
            };
            tableList.push(tableObj);
          });
          this.tableList = tableList;
        }
      });
    },
    // 打开取整规则
    openRound(tableTitleIndex) {
      this.tableTitleIndex = tableTitleIndex
      this.roundDialog = true
    },
    // 关闭取整规则
    closeRoundDialog() {
      this.roundDialog = false
    },
  }
};
</script>
<style lang="scss" scoped>
.logistics-inquiry {
  flex: 1;
  .table-container {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .message {
      display: flex;
      padding-bottom: 16px;
      p {
        margin-right: 32px;
      }
    }
    .throw-rule {
      height: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 14px;
      color: #666;
      .input-container {
        position: relative;
        color: #999999;
        .unit {
          position: absolute;
          right: 4px;
          top: 9px;
        }
      }
    }
    .table {
      margin-bottom: 16px;
    }
  }
  .el-dialog {
    .el-form {
      padding: 0 30px 0 10px;
      .el-select {
        width: 100%;
      }
    }
    .list {
      padding: 0 18px;
      max-height: 235px;
      overflow: auto;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .interval {
          align-items: center;
          display: flex;
          .blank {
            padding: 0 10px;
          }
          .el-input {
            width: 100px;
          }
          .btn-text {
            font-size: 12px;
            margin-left: 16px;
          }
          .fixedPrice {
            margin-left: 10px;
          }
        }
      }
      .item:last-child {
        margin-bottom: 0;
      }
    }
    .express-inquiry {
      margin-top: 10px;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
    .throw-rule {
      height: 32px;
      display: flex;
      align-items: center;
      margin-left: 16px;
      font-size: 14px;
      color: #666;
    }
  }
  .w100 {
    width: 100px;
  }
}
</style>
<style lang="scss">
.logistics-inquiry {
  .throw-rule {
    .w100 {
      .el-input__suffix {
        height: 32px;
        top: 0px;
        .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }
}
</style>
